import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreatmentCardVM, TreatmentPlanDialogDate, TreatmentPlanDialogService } from '@libs/charting';
import { Store } from '@ngrx/store';
import { selectNewAppointment, selectUserSiteId } from '@libs/store';
import { routes } from '@libs/utils';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { DropdownComponent, InputComponent } from '@libs/ui-lib';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { ReasonSelectorModalService } from '../reason-selector-modal.service';

@Component({
  selector: 'lib-treatment-plan-selector',
  templateUrl: './treatment-plan-selector.component.html',
  styleUrl: './treatment-plan-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TreatmentPlanDialogService],
  imports: [CommonModule, SvgIconComponent, InputComponent, TranslateModule, DropdownComponent, LottieComponent],
})
export class TreatmentPlanSelectorComponent implements OnInit {
  private readonly treatmentPlanDialogService = inject(TreatmentPlanDialogService);
  private readonly reasonSelectorModalService = inject(ReasonSelectorModalService);

  public selectedReasons = this.reasonSelectorModalService.selectedReasons;

  private readonly store = inject(Store);
  private readonly selectedSiteId = this.store.selectSignal(selectUserSiteId);

  public readonly viewModel = this.treatmentPlanDialogService.viewModel;
  protected readonly TreatmentPlanDialogDate = TreatmentPlanDialogDate;

  public lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };

  public ngOnInit(): void {
    const newAppointmentState = this.store.selectSignal(selectNewAppointment);

    // Set the siteId and patientId on the service, then init will load progress notes locally
    this.treatmentPlanDialogService.setSiteId(this.selectedSiteId() ?? routes.showcaseSiteId);
    this.treatmentPlanDialogService.setPatientId(newAppointmentState().patient?.id ?? '');
    this.treatmentPlanDialogService.init();
  }

  public selectItem(item: TreatmentCardVM): void {
    this.reasonSelectorModalService.addReason({
      abbreviation: item.abbreviation,
      code: item.dentalCode,
      name: item.treatmentName,
    });
  }

  public deselectItem(item: TreatmentCardVM): void {
    this.reasonSelectorModalService.removeReason(item.dentalCode);
  }

  public isSelected(item: TreatmentCardVM): boolean {
    return this.selectedReasons().some((selectedItem) => selectedItem.code === item.dentalCode);
  }

  protected onSearchQueryChange(query: string): void {
    this.treatmentPlanDialogService.updateSearchQuery(query);
  }

  protected onDateOptionChange(option: TreatmentPlanDialogDate | TreatmentPlanDialogDate[] | null): void {
    this.treatmentPlanDialogService.onDateOptionChange(option);
  }
}
